module.exports = __webpack_public_path__ + "img/car-18.17576289.jpg";